import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BarChart2, Home, GitCompare, Menu, X, Search, BookOpen, Gift, TrendingUp } from 'lucide-react';
import { ThemeSwitcher } from './ThemeSwitcher';
import { PRODUCT_CATEGORIES } from './header/headerConstants';
import { CategoriesDropdown } from './header/HeaderDropdowns';
import { MobileMenu } from './header/MobileMenu';
import { getPrimaryNav } from '../../config/navigation';

const NAV_ICONS = { home: Home, 'find-products': Search, 'buying-guides': BookOpen, deals: Gift, trending: TrendingUp, compare: GitCompare };

export function ModernHeader({ onNavigateHome }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(PRODUCT_CATEGORIES.mainCategories[0]);

  const handleHomeClick = (e) => {
    if (onNavigateHome) {
      e.preventDefault();
      onNavigateHome();
    }
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    // Prevent body scroll when mobile menu is open
    document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
  }, [isMenuOpen]);
  
  return (
    <header className="backdrop-blur-md bg-[#f5f4fd1a] border-b border-white/20 dark:bg-dark-card/80 dark:border-dark-primary backdrop-blur-sm sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            onClick={handleHomeClick}
            className="text-slate-900 dark:text-white text-xl font-bold flex items-center gap-2 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >
            <BarChart2 className="w-6 h-6 text-blue-600 dark:text-blue-400" />
            {/* NOTE: Changed from TechieDay to match the screenshot */}
            <span>TechieDay</span> 
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6">
            {getPrimaryNav().map((item) => {
              if (item.menu === 'categories') {
                return <CategoriesDropdown key={item.key} activeCategory={activeCategory} setActiveCategory={setActiveCategory} />;
              }
              const Icon = NAV_ICONS[item.key];
              return (
                <Link
                  key={item.key}
                  to={item.to}
                  onClick={item.key === 'home' ? handleHomeClick : undefined}
                  className="flex items-center gap-2 text-slate-600 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 font-medium transition-colors"
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </Link>
              );
            })}
          </div>

          {/* Mobile Menu Button & Theme Switcher */}
          <div className="flex items-center gap-2">
            <ThemeSwitcher />
            <button
              className="lg:hidden p-2 text-slate-600 dark:text-slate-300"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        <MobileMenu isOpen={isMenuOpen} onLinkClick={handleLinkClick} />
      </nav>
    </header>
  );
}